import React from "react";

const ConditionsUtilisation = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">
          Conditions d'utilisation – Kok Batay
        </h1>
        <p className="text-gray-600 mb-6">
          Bienvenue sur Kok Batay. En accédant à notre plateforme, vous acceptez
          les présentes conditions d’utilisation. Veuillez les lire attentivement.
        </p>

        {/* 1. Utilisation de la plateforme */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            1. Utilisation de la plateforme
          </h2>
          <p className="text-gray-700">
            Kok Batay est une plateforme de divertissement où les utilisateurs
            peuvent suivre et parier sur des combats virtuels de coqs.
            Toute utilisation abusive, frauduleuse ou contraire à la loi
            entraînera la suspension ou la suppression du compte.
          </p>
        </section>

        {/* 2. Création de compte */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            2. Création de compte
          </h2>
          <p className="text-gray-700">
            Pour utiliser certaines fonctionnalités, vous devez créer un compte
            avec des informations exactes et à jour. Vous êtes responsable de
            la confidentialité de vos identifiants et de toute activité effectuée
            avec votre compte.
          </p>
        </section>

        {/* 3. Paiements et retraits */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            3. Paiements et retraits
          </h2>
          <p className="text-gray-700">
            Les recharges de solde et les retraits doivent être effectués via les
            moyens de paiement autorisés sur la plateforme. Kok Batay ne sera pas
            tenu responsable des pertes dues à des transactions effectuées en
            dehors du site officiel.
          </p>
        </section>

        {/* 4. Responsabilité de l'utilisateur */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            4. Responsabilité de l'utilisateur
          </h2>
          <p className="text-gray-700">
            Vous vous engagez à utiliser Kok Batay uniquement dans un but
            légal et conforme à l’éthique. Vous acceptez de ne pas utiliser la
            plateforme pour harceler, menacer ou diffamer qui que ce soit.
          </p>
        </section>

        {/* 5. Modifications des conditions */}
        <section className="mb-6">
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            5. Modifications des conditions
          </h2>
          <p className="text-gray-700">
            Kok Batay se réserve le droit de modifier ces conditions à tout
            moment. Les utilisateurs seront informés des mises à jour et
            l’utilisation continue du service constituera une acceptation
            des nouvelles conditions.
          </p>
        </section>

        {/* 6. Contact */}
        <section>
          <h2 className="text-xl font-semibold text-orange-600 mb-2">
            6. Contact
          </h2>
          <p className="text-gray-700">
            Pour toute question concernant ces conditions, contactez-nous à :
            <span className="font-semibold"> support@kokbatay.com</span>.
          </p>
        </section>

        {/* Bouton retour */}
        <div className="mt-8">
          <a
            href="/"
            className="inline-block bg-orange-500 text-white px-6 py-2 rounded-lg hover:bg-orange-600"
          >
            Retour à l'accueil
          </a>
        </div>
      </div>
    </div>
  );
};

export default ConditionsUtilisation;
